 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import OEBPSPRA from '@/components/OEBPS/pra'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSMINI_TOC from '@/components/OEBPS/mini_toc'
 import OEBPSCPN from '@/components/OEBPS/cpn'
 import OEBPSDED from '@/components/OEBPS/ded'
 import OEBPSPRO from '@/components/OEBPS/pro'
 import OEBPSP01 from '@/components/OEBPS/p01'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import OEBPSC02 from '@/components/OEBPS/c02'
 import OEBPSC03 from '@/components/OEBPS/c03'
 import OEBPSC04 from '@/components/OEBPS/c04'
 import OEBPSC05 from '@/components/OEBPS/c05'
 import OEBPSC06 from '@/components/OEBPS/c06'
 import OEBPSC07 from '@/components/OEBPS/c07'
 import OEBPSC08 from '@/components/OEBPS/c08'
 import OEBPSP02 from '@/components/OEBPS/p02'
 import OEBPSC09 from '@/components/OEBPS/c09'
 import OEBPSC10 from '@/components/OEBPS/c10'
 import OEBPSC11 from '@/components/OEBPS/c11'
 import OEBPSC12 from '@/components/OEBPS/c12'
 import OEBPSC13 from '@/components/OEBPS/c13'
 import OEBPSC14 from '@/components/OEBPS/c14'
 import OEBPSC15 from '@/components/OEBPS/c15'
 import OEBPSC16 from '@/components/OEBPS/c16'
 import OEBPSC17 from '@/components/OEBPS/c17'
 import OEBPSEPL from '@/components/OEBPS/epl'
 import LOVE_2 from '@/components/love_2'
 import OEBPSNOTS from '@/components/OEBPS/nots'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSAUN from '@/components/OEBPS/aun'
 import OEBPSATA from '@/components/OEBPS/ata'
 import OEBPSALS from '@/components/OEBPS/als'
 import OEBPSINDX from '@/components/OEBPS/indx'
 import OEBPSINSRT from '@/components/OEBPS/insrt'
 import OEBPSNEWSLETTER from '@/components/OEBPS/newsletter'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSCOP from '@/components/OEBPS/cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/OEBPS/pra",
 			"name" : "OEBPS/pra",
 			"component" : OEBPSPRA
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/mini_toc",
 			"name" : "OEBPS/mini_toc",
 			"component" : OEBPSMINI_TOC
 		},
 		{
 			"path" : "/OEBPS/cpn",
 			"name" : "OEBPS/cpn",
 			"component" : OEBPSCPN
 		},
 		{
 			"path" : "/OEBPS/ded",
 			"name" : "OEBPS/ded",
 			"component" : OEBPSDED
 		},
 		{
 			"path" : "/OEBPS/pro",
 			"name" : "OEBPS/pro",
 			"component" : OEBPSPRO
 		},
 		{
 			"path" : "/OEBPS/p01",
 			"name" : "OEBPS/p01",
 			"component" : OEBPSP01
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
 		{
 			"path" : "/OEBPS/c02",
 			"name" : "OEBPS/c02",
 			"component" : OEBPSC02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js